var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import LazyLoad from "react-lazyload";
import { Image } from "../image/Image";
import { ImagePlaceholder } from "../placeholder/Image";
var Picture = /* @__PURE__ */ __name(function Picture2(_ref) {
  var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? "" : _ref$alt, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, sizes = _ref.sizes, src = _ref.src, srcSet = _ref.srcSet, _ref$imgProps = _ref.imgProps, imgProps = _ref$imgProps === void 0 ? {} : _ref$imgProps, _ref$lazyload = _ref.lazyload, lazyload = _ref$lazyload === void 0 ? null : _ref$lazyload;
  if (!sizes || !src || !srcSet) {
    return null;
  }
  var pictureComponent = /* @__PURE__ */ React.createElement("picture", {
    className
  }, srcSet.webp ? /* @__PURE__ */ React.createElement("source", {
    type: "image/webp",
    srcSet: srcSet.webp,
    sizes
  }) : null, /* @__PURE__ */ React.createElement(Image, _extends({
    src,
    srcSet: srcSet.img,
    sizes
  }, imgProps, {
    alt: alt || imgProps && imgProps.alt || ""
  })));
  return lazyload ? /* @__PURE__ */ React.createElement(LazyLoad, lazyload, pictureComponent) : pictureComponent;
}, "Picture");
var PicturePlaceholder = ImagePlaceholder(Picture);
export {
  Picture,
  PicturePlaceholder
};
